import {
  Box,
  Button,
  Flex,
  InlineStack,
  PanelHeader,
  Tooltip,
  TooltipContent,
} from '@customerio/pluma-components/react';
import { TableListCount } from '@/features/people';
import { RelationshipsTableActions } from './relationships-table-actions';

type RelationshipsTableHeaderProps = {
  /** Lowercase people noun, as the count copy reads mid-sentence. */
  countNoun: string;
  /** Every relationship the object has; `-1` until the first page resolves. */
  total: number;
  selectedCount: number;
  isAllSelected: boolean;
  isPageSelected: boolean;
  canDelete: boolean;
  onClearSelection: () => void;
  onDeleteSelected: () => void;
  onDeleteAll: () => void;
  /** `journeys/object_relationships/edit`, which Ember gates the column picker on. */
  canEditColumns: boolean;
  onEditColumns: () => void;
};

export function RelationshipsTableHeader({
  countNoun,
  total,
  selectedCount,
  isAllSelected,
  isPageSelected,
  canDelete,
  onClearSelection,
  onDeleteSelected,
  onDeleteAll,
  canEditColumns,
  onEditColumns,
}: RelationshipsTableHeaderProps) {
  return (
    <PanelHeader>
      <Flex w="full" alignItems="center" flexWrap="wrap" gap="150">
        <InlineStack gap="150" alignBlock="center">
          <TableListCount
            allSelected={isAllSelected}
            totalCount={total}
            selectedCount={selectedCount}
            singularName={countNoun}
          />
          <RelationshipsTableActions
            selectedCount={selectedCount}
            total={total}
            canDelete={canDelete}
            isPageSelected={isPageSelected}
            onClearSelection={onClearSelection}
            onDeleteSelected={onDeleteSelected}
            onDeleteAll={onDeleteAll}
          />
        </InlineStack>
        <Box flex={1} />
        <Tooltip placement="top" isCustom>
          {(context) => (
            <>
              <Button
                variant="secondary"
                size="sm"
                icon="table-columns"
                isIconOnly
                isDisabled={!canEditColumns}
                aria-label="Edit displayed attributes"
                onClick={onEditColumns}
                ref={context.reference.setReference}
                {...context.reference.getReferenceProps()}
                data-test-edit-displayed-attributes-button
              />
              <TooltipContent>Edit displayed attributes.</TooltipContent>
            </>
          )}
        </Tooltip>
      </Flex>
    </PanelHeader>
  );
}
